import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaTripleYpsili';
const args = {};

export class OligonKentimaTripleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
